export default defineNuxtPlugin((nuxtApp) => {
  // Reload the page when a chunk fails to load
  // This handles cases where users have cached an old version
  // but chunks have been updated in a new deployment

  let reloadCount = 0;
  const maxReloads = 3;
  const reloadWindow = 30000; // 30 seconds

  nuxtApp.hook("app:chunkError", () => {
    const now = Date.now();
    const lastReload = localStorage.getItem("chunk-error-reload");

    if (lastReload && now - parseInt(lastReload) < reloadWindow) {
      reloadCount++;
      if (reloadCount >= maxReloads) {
        console.error("Too many chunk error reloads, stopping");
        return;
      }
    } else {
      reloadCount = 1;
    }

    localStorage.setItem("chunk-error-reload", now.toString());
    window.location.reload();
  });
});
